
module.directive('phoneNumberValidator', function(phoneFilter) {
    return {
        require: "ngModel",
        link: function(scope, element, attrs, ngModel) {

            ngModel.$formatters.push(phoneFilter);

            ngModel.$parsers.push(function(value) {
                if (!value || value[0] === '+') { return value; }
                value = value.replace(/[^\d\+]/g, "");
                value = value.replace(/(?!^)\+/g, "");
                value = value.replace(/^(1|0)+/, "");
                return value;
            });

            ngModel.$validators.phone = function(modelValue, viewValue) {
                var value = modelValue || viewValue;
                if (!value) { return true; }
                if (value[0] == '+') { return true; }
                else if (value.length >= 10) { return true; }
                return false;
            };

        }
    };
});
